import * as actionTypes from './gridActionTypes';
import { refreshGrid } from './gridActions';

export const _initialGridState = {
	pristine: true, //Whether or not the grid has ever received data
	needsRefresh: false,
	page: 0,
	totalElements: 0,
	pageLength: 10,
	filter: {
		searchParam: '',
		status: ''
	},
	advancedSearchOpen: false,
	sorting: {
		sortBy: '',
		sortOrder: ''
	},
	order: [],
	primaryKey: '',
	countrySummaryActions: {
		qualifiedCountries: '',
		notQualifiedCountries: '',
		action: '',
		distributAndDoNotDistributeCountries: ''
	},
	blkAcknowledgeActions: {
		qualifiedSN: '',
		noPermission:'',
		notDownloaded:'',
		alreadyAcknowledged:''
	}
};

/**
 * gridReducer is responsible for managing a single grid's state
 */
const gridReducer = (state = _initialGridState, action) => {
	switch (action.type) {
		case actionTypes.LOAD_GRID_DATA: {
			if (!action.response || !action.response.data) {
				return {
					...state,
					pristine: false
				};
			}

			let keys = [];
			let results;
			const { response: { data } } = action;
			const { primaryKey } = state;
			if (action.gridName === 'slSafetyRecipientCommentGrid'){
				results = data.getReciAckComments && data.getReciAckComments.content ? data.getReciAckComments.content : [] ;
			}else if(action.gridName === 'recipientDetails' && data.orgDetails){
				results = data.orgDetails.content ? data.orgDetails.content : data.orgDetails;
			}else{
				results = data.content ? data.content : data;         
			}
		
			//If we have a primary key, use it
			//Otherwise, use the index as the primary key
			keys = results.map((obj, index) => (primaryKey ? obj[state.primaryKey] : index));
			return {
				...state,
				pristine: false,
				needsRefresh: false,
				totalElements: data.totalElements || keys.length || 0,
				order: keys,
				pageLength: action.gridName === 'safetyletterRecipient' && state.pageLength === 10 ? 25 : action.gridName === 'ibRecipient' && state.pageLength === 10 ? 25 : action.gridName === 'CreateGapPacketResultsGrid' && state.pageLength === 10 ? 50 : state.pageLength
			};
		}
		case actionTypes.REFRESH_RECIPIENT: {
			return {
				...state,
				needsRefresh: true,
				page: 0,
				pageLength: 10,
				sorting: {
					sortBy: '',
					sortOrder: ''
				},
				filter: {
					searchParam: '',
					status: ''
				},
				advancedSearchOpen: false
			};
		}
		case actionTypes.REFRESH_IB_RECIPIENT: {
			return {
				...state,
				needsRefresh: true,
				page: 0,
				pageLength: 10,
				sorting: {
					sortBy: state.sorting.sortBy ? state.sorting.sortBy : '',
					sortOrder: state.sorting.sortOrder ? state.sorting.sortOrder : ''
				},
				filter: state.filter,
				advancedSearchOpen: true
			};
		}
		case actionTypes.REFRESH_MANAGEMENT: {
			return {
				...state,
				needsRefresh: true,
				page: 0,
				sorting: {
					sortBy: state.sorting.sortBy ? state.sorting.sortBy : action.gridName === 'safetyAdminGrid' ? 'createdDate,safetyId' : '',
					sortOrder: state.sorting.sortOrder ? state.sorting.sortOrder:  action.gridName === 'safetyAdminGrid' ? 'desc' : ''
				},
				filter: {
					searchParam: '',
				}
			};
		}

		case actionTypes.REFRESH_SORT: {
			const { filter } = action;
	
			return {
				...state,
				needsRefresh: state.filter !== filter,
				page: 0,
				filter: filter,
				sorting: {
					sortBy: action.filter.searchParam === state.filter.searchParam ? state.sorting.sortBy : '',
					sortOrder: action.filter.searchParam === state.filter.searchParam ? state.sorting.sortOrder : ''
				} 
			};
		}

		case actionTypes.FILTER_HOME_PAGE_GRID: {
			const { filter } = action;	

			return {
				...state,
				needsRefresh: state.filter !== filter,
				page: 0,
				filter: filter,
				sorting: {
					sortBy: action.gridName === 'safetyAdminGrid' ?  
					(action.filter.searchParam === state.filter.searchParam || action.filter.status === state.filter.status || 
						filter.distDue === state.filter.distuDue || filter.sentDue === state.filter.sentDue) ? state.sorting.sortBy : 'createdDate,safetyId'
					: (action.filter.searchParam === state.filter.searchParam || action.filter.status === state.filter.status || 
						filter.distDue === state.filter.distuDue || filter.sentDue === state.filter.sentDue) ? state.sorting.sortBy : '',
					sortOrder: action.gridName === 'safetyAdminGrid' ? 
					(action.filter.searchParam === state.filter.searchParam || action.filter.status === state.filter.status || 
						filter.distDue === state.filter.distuDue || filter.sentDue === state.filter.sentDue) ? state.sorting.sortOrder :  'desc' 
					: (action.filter.searchParam === state.filter.searchParam || action.filter.status === state.filter.status || 
						filter.distDue === state.filter.distuDue || filter.sentDue === state.filter.sentDue) ? state.sorting.sortOrder : ''
				} 
			};
		}
		
		case actionTypes.SORT_GRID: {
			const { sorting } = state;
			const sameColumnSort = sorting.sortBy === action.sortBy;

			let sortOrder = 'asc';
			//setting initial value as 'desc' for Overdue Ack grid sorting by title 
			//since grid data is sorted by "title,asc" on initial load
			if(action.gridName==='overdueAckResultsGrid' && action.sortBy==='title'){
				sortOrder='desc';
			}
			if (sameColumnSort) {
				sortOrder = sorting.sortOrder === 'asc' ? 'desc' : 'asc';
			}

			return {
				...state,
				needsRefresh: true,
				page: 0,
				sorting: {
					sortBy: action.sortBy,
					sortOrder
				}
			};
		}
		case actionTypes.FILTER_GRID: {
			const { filter } = action;	

			return {
				...state,
				needsRefresh: state.filter !== filter,
				page: 0,
				filter: filter, 
				sorting: {
					sortBy: (action.gridName === 'recipientsGrid' || action.gridName === 'individualRecipients' ? 
					(action.filter && action.filter.searchParam && action.filter.searchParam.length >= 1 ? '' : (state.sorting.sortBy || (action.gridName === 'individualRecipients'? 
					'lastName,safetyOrgUserId': ''))) : state.sorting.sortBy),
					sortOrder: (action.gridName === 'recipientsGrid' || action.gridName === 'individualRecipients' ? 
					(action.filter && action.filter.searchParam && action.filter.searchParam.length >= 1 ? '' : (state.sorting.sortOrder || (action.gridName === 'individualRecipients'? 
					'asc': ''))) : state.sorting.sortOrder)
				}
			};
		}
		case actionTypes.TOGGLE_ADVANCED_SEARCH: {
			return {
				...state,
				advancedSearchOpen: !state.advancedSearchOpen
			};
		}
		case actionTypes.SHOW_ADVANCED_SEARCH: {
			return {
				...state,
				advancedSearchOpen: true
			};
		}
		case actionTypes.GRID_REFRESHED: {
			return {
				...state,
				needsRefresh: false
			};
		}
		case actionTypes.REFRESH_GRID: {
			return {
				...state,
				needsRefresh: true
			};
		}
		case actionTypes.REFRESH_PAGINATION: {
			return {
				...state,
				page: 0,
				totalElements: 0,
				pageLength: 10,
			};
		}
		case actionTypes.CHANGE_PAGE_LENGTH: {
			if (!action.pageLength) {
				return state;
			}

			return {
				...state,
				needsRefresh: state.pageLength !== action.pageLength,
				page: 0,
				pageLength: action.pageLength
			};
		}
		case actionTypes.COUNTRY_GRID_ACTION: {
			return {
				...state,
				countrySummaryActions: {
					qualifiedCountries: action.countriesList.qualifiedCountries,
					notQualifiedCountries: action.countriesList.notQualifiedCountries,
					distributAndDoNotDistributeCountries: action.countriesList.distributAndDoNotDistributeCountries,
					action: action.countriesList.action
				}
			};
		}

		case actionTypes.SN_GRID_ACTION: {
			return {
				...state,
				blkAcknowledgeActions: {
					qualifiedSN: action.filterEligibleAndNoteligibelSN.qualifiedSN,
		  			noPermission : action.filterEligibleAndNoteligibelSN.noPermission,
		  			notDownloaded : action.filterEligibleAndNoteligibelSN.notDownloaded,
		  			alreadyAcknowledged : action.filterEligibleAndNoteligibelSN.alreadyAcknowledged
				}
			};
		}

		case actionTypes.GOTO_PAGE: {
			const { pageLength } = state;
			return changePage(state, action, action.pageNumber, pageLength);
		}
		case actionTypes.NEXT_PAGE: {
			const { page, pageLength } = state;
			return changePage(state, action, page + 1, pageLength);
		}
		case actionTypes.PREV_PAGE: {
			const { page, pageLength } = state;
			return changePage(state, action, page - 1, pageLength);
		}
		case actionTypes.FIRST_PAGE: {
			const { pageLength } = state;
			return changePage(state, action, 0, pageLength);
		}
		case actionTypes.LAST_PAGE: {
			const { pageLength, totalElements } = state;
			const numPages = getNumberOfPages(totalElements, pageLength);
			return changePage(state, action, numPages, pageLength);
		}
		default: {
			return state;
		}
	}
};

/**
 * This reducer is responsible for managing which grids are registered in the grid,
 * and making the gridReducer's job easier by giving it only the state for a particular grid
 */
const reducer = (state = {}, action) => {
	switch (action.type) {
		case actionTypes.REGISTER_GRID: {
			if (state[action.gridName]) {
				return state;
			}

			return {
				...state,
				[action.gridName]: {
					..._initialGridState,
					sorting: {
						sortBy: action.gridName === 'individualRecipients' ? 'lastName,safetyOrgUserId' : _initialGridState.sorting.sortBy,
						sortOrder: action.gridName === 'individualRecipients' ? 'asc' : _initialGridState.sorting.sortOrder
					},
					primaryKey: action.primaryKey
				}
			};
		}
		case actionTypes.UNREGISTER_GRID: {
			const { [action.gridName]: removed, ...newState } = state;

			return newState;
		}
		case actionTypes.REFRESH_ALL: {
			return Object.entries(state).reduce((acc, [gridName, gridState]) => {
				return {
					...acc,
					[gridName]: gridReducer(gridState, refreshGrid(gridName))
				};
			}, state);
		}
		default: {
			if (action.gridName && state[action.gridName]) {
				const currentState = state[action.gridName];
				const gridState = gridReducer(state[action.gridName], action);

				if (currentState !== gridState) {
					return {
						...state,
						[action.gridName]: gridState
					};
				}
			}
			return state;
		}
	}
};

export default reducer;

/** Paging helpers */
const changePage = (state, action, newPage, pageLength) => {
	const { totalElements, page } = state;
	const numPages = getNumberOfPages(totalElements, pageLength);
	const nextPage = getNextPage(newPage, numPages);

	return {
		...state,
		needsRefresh: page !== nextPage,
		page: nextPage
	};
};

const getNumberOfPages = (totalElements, pageLength) => Math.ceil(totalElements / pageLength) - 1;

const getNextPage = (nextPage, totalPages) => {
	if (nextPage < 0) {
		return 0;
	} else if (nextPage > totalPages) {
		return totalPages;
	}
	return nextPage;
};
